import { useHypertune } from '@/flags/hypertune/generated/hypertune.react';

export function useDisloyaltyDummyRateFlag(args: { hotelReferenceId: string }) {
  return useHypertune().disloyaltyDummyRate({
    fallback: false,
    args: { hotel: { referenceId: args.hotelReferenceId } },
  });
}
